import { useEffect } from 'react';

import { EmcNeedHelp } from '@components';
import { Notification } from '@elements/notification';
import { Text } from '@elements/text';
import { useEmcTraveller } from '@hooks';
import { i18n } from '@i18n';
import { sendAnalyticsEvent } from '@utils';

import { BoostSummary } from './boostSummary/boostSummary.component';
import { ConditionCard } from './conditionCard/conditionCard.component';
import { EmcScreeningResultsFooterButtons } from './emcScreeningResultsFooterButtons.component';

export const EmcScreeningResult = () => {
  const { emcCurrentTraveller } = useEmcTraveller();

  useEffect(() => {
    sendAnalyticsEvent('Medical assessment completed', {
      TravellerID: emcCurrentTraveller?.travellerId ?? '',
      Coverage: emcCurrentTraveller?.isCovered ? 'covered' : 'not covered',
    });
  }, [emcCurrentTraveller?.travellerId, emcCurrentTraveller?.isCovered]);

  return (
    <div>
      {!emcCurrentTraveller?.isCovered && (
        <div className="mb-8">
          <Notification
            header={i18n.t('emcShared.screeningResult.notification.heading')}
            body={i18n.t('emcShared.screeningResult.notification.description')}
            variant="error"
          />
        </div>
      )}

      <div>
        {emcCurrentTraveller?.isCovered && (
          <Text variant="body-16/r" className="pb-4">
            {i18n.t('emcShared.screeningResult.summary.description')}
          </Text>
        )}
        <div className="md:w-[548px]">
          <ConditionCard coveredType="covered" className="mb-4" />
          <ConditionCard coveredType="notCovered" className="mb-4" />
          {import.meta.env.VITE_ENV !== 'prod' && emcCurrentTraveller?.isCovered ? (
            <Text variant="body-16/sb" className="my-2 text-red-500 ">
              Risk Score: {emcCurrentTraveller?.riskScore}
            </Text>
          ) : null}
        </div>

        {emcCurrentTraveller?.assessmentNumber && (
          <Text variant="body-16/sb" className="pb-4">
            {i18n.t('emcShared.screeningResult.assessmentNo', {
              assessmentNumber: emcCurrentTraveller?.assessmentNumber,
            })}
          </Text>
        )}
      </div>

      {emcCurrentTraveller?.isCovered && <BoostSummary />}
      <div className="flex flex-col md:flex-row items-center gap-10 md:justify-end md:mt-5">
        <EmcScreeningResultsFooterButtons />
        <EmcNeedHelp className="sm:hidden mt-3 mb-8" />
      </div>
    </div>
  );
};
